<div class="custom-date-picker-wrapper fw fh">
    <div class="calendar-block fw">
        <div class="split from">
            <p-calendar class="unilever-calendar no-time-split" [ngClass]="{'disabled':isStartDisable}"
                [(ngModel)]="customDate.from" ngDefaultControl [disabled]="isStartDisable" [inline]="true"
                #deadline="ngModel" [showTime]="false" [minDate]="today" (onSelect)="customDateChange()"
                hourFormat="24">
            </p-calendar>
        </div>
        <div class="split to" [ngClass]="{'disabled':isEndDisable}">
            <p-calendar class="unilever-calendar no-time-split" [(ngModel)]="customDate.to" ngDefaultControl
                [disabled]="isEndDisable" [inline]="true" [showTime]="false" [minDate]="today"
                (onSelect)="customDateChange()"></p-calendar>
        </div>
    </div>
    <div class="button-block">
        <button mat-raised-button class="cancel spc-btn" mat-dialog-close>{{'common.cancel' | translate}}</button>
        <button mat-raised-button class="ok spc-btn" [disabled]="!selectionCorrect" (click)="applyCustomDate()"
            color="primary">{{'common.ok' | translate}}</button>
    </div>
</div>